<template>
    <div>
        <menu-bar></menu-bar>
        <div style="margin-top: 60px"></div>
        <div class="container">

            <div class="row">

                <div style="text-align: center;">
                    <img src="image/logo2.png">
                </div>

                <div class="main" >

                    <br/><br/>

                    <form role="form" >

                        <div class="form-group">
                            <label for="inputUsernameEmail">EMAIL</label>
                            <input v-model="data.username" type="text" class="form-control" id="inputUsernameEmail">
                        </div>

                        <div class="form-group">
                            <label for="inputPassword">SENHA</label>
                            <input @keyup.enter="auth()" v-model="data.password" autocomplete="0" type="password" class="form-control" id="inputPassword">
                        </div>

                        <button @click="auth()" type="button" class="btn btn btn-info btn-block">
                            ACESSAR
                        </button>

                        <a class="pull-right" href="#">Esqueceu sua Senha?</a>
                    </form>

                    <br/><br/>

                    <a href="#/cobertura" type="button" class="btn btn-default btn-block">
                        VER ÁREA DE COBERTURTA
                    </a>

                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { Usuario } from "../class/usuario";
import Vue from "vue";

export default {
    data() {
        return {
            data: {
                username: "",
                password: ""
            }
        };
    },
    methods: {
        auth() {
            Usuario.auth(this.data)
                .then(data => {
                    Vue.http.headers.common["Authorization"] =
                        "JWT " + data.token;
                    window.localStorage.setItem("token-ips", data.token);
                    window.localStorage.setItem("token-ca", data.catoken);
                    this.$store.commit("login", data);
                    this.$router.push("/");
                })
                .catch(err => console.log(err));
        }
    }
};
</script>
<style>
body {
    padding-top: 15px;
    font-size: 12px;
}

.main {
    max-width: 320px;
    margin: 0 auto;
}

.login-or {
    position: relative;
    font-size: 18px;
    color: #aaa;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.span-or {
    display: block;
    position: absolute;
    left: 50%;
    top: -2px;
    margin-left: -25px;
    background-color: #fff;
    width: 50px;
    text-align: center;
}

.hr-or {
    background-color: #cdcdcd;
    height: 1px;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}

h3 {
    text-align: center;
    line-height: 300%;
}
</style>
